
import { Vue, Component } from 'vue-property-decorator';
import TooLData from '@/data/ToolData';

@Component
export default class ToolMixin extends Vue {
  ToolList = TooLData.ToolList;

  Period = {
    start: {
      date: this.$moment()
        .startOf('day')
        .toDate(),
    },
    end: {
      date: this.$moment()
        .endOf('day')
        .toDate(),
    },
  };

  currentTool = 'Today';

  currentMode = 'day';

  onSubmit() {
    console.log('onSubmit');
  }

  handleTool(Tool) {
    this.currentTool = Tool;
    if (Tool !== 'Next' && Tool !== 'Previous') {
      this.currentMode = Tool.includes('day') ? 'day' : Tool.split(' ')[1].toLowerCase();
    }
    const TYPE = {
      day: 'day',
      week: 'isoWeek',
      month: 'month',
    };
    switch (Tool) {
      case 'Previous':
        this.Period.start.date = this.$moment(this.Period.start.date)
          .subtract(
            this.currentMode === 'week'
              ? 7
              : 1,
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .startOf(
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .toDate();
        this.Period.end.date = this.$moment(this.Period.end.date)
          .subtract(
            this.currentMode === 'week'
              ? 7
              : 1,
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .endOf(
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .toDate();
        break;
      case 'Next':
        this.Period.start.date = this.$moment(this.Period.start.date)
          .add(
            this.currentMode === 'week'
              ? 7
              : 1,
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .startOf(
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .toDate();
        this.Period.end.date = this.$moment(this.Period.end.date)
          .add(
            this.currentMode === 'week'
              ? 7
              : 1,
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .endOf(
            this.currentMode === 'week'
              ? 'day'
              : TYPE[this.currentMode],
          )
          .toDate();
        break;
      case 'Today':
        this.Period.start.date = this.$moment()
          .startOf(TYPE.day)
          .toDate();
        this.Period.end.date = this.$moment()
          .endOf(TYPE.day)
          .toDate();
        break;
      case 'Yesterday':
        this.Period.start.date = this.$moment().subtract(1, TYPE.day).startOf(TYPE.day).toDate();
        this.Period.end.date = this.$moment().subtract(1, TYPE.day).endOf(TYPE.day).toDate();
        break;
      case 'This Week':
        if (Number(this.$moment()) >= Number(this.$moment().clone().weekday(2))) {
          this.Period.start.date = this.$moment().clone().weekday(2)
            .startOf(TYPE.day)
            .toDate();
          this.Period.end.date = this.$moment().clone().weekday(2)
            .add(6, TYPE.day)
            .endOf(TYPE.day)
            .toDate();
        } else {
          this.Period.start.date = this.$moment().clone().weekday(2)
            .subtract(7, TYPE.day)
            .startOf(TYPE.day)
            .toDate();
          this.Period.end.date = this.$moment().clone().weekday(2)
            .subtract(1, TYPE.day)
            .endOf(TYPE.day)
            .toDate();
        }
        break;
      case 'Last Week':
        if (Number(this.$moment()) >= Number(this.$moment().clone().weekday(2))) {
          this.Period.start.date = this.$moment().clone().weekday(2)
            .subtract(7, TYPE.day)
            .startOf(TYPE.day)
            .toDate();
          this.Period.end.date = this.$moment().clone().weekday(2)
            .subtract(1, TYPE.day)
            .endOf(TYPE.day)
            .toDate();
        } else {
          this.Period.start.date = this.$moment().clone().weekday(2)
            .subtract(14, TYPE.day)
            .startOf(TYPE.day)
            .toDate();
          this.Period.end.date = this.$moment().clone().weekday(2)
            .subtract(8, TYPE.day)
            .endOf(TYPE.day)
            .toDate();
        }
        break;
      case 'This Month':
        this.Period.start.date = this.$moment()
          .startOf(TYPE.month)
          .toDate();
        this.Period.end.date = this.$moment()
          .endOf(TYPE.month)
          .toDate();
        break;
      case 'Last Month':
        this.Period.start.date = this.$moment()
          .subtract(1, TYPE.month)
          .startOf(TYPE.month)
          .toDate();
        this.Period.end.date = this.$moment()
          .subtract(1, TYPE.month)
          .endOf(TYPE.month)
          .toDate();
        break;
      default:
        this.Period.start.date = this.$moment()
          .startOf(TYPE.day)
          .toDate();
        this.Period.end.date = this.$moment()
          .endOf(TYPE.day)
          .toDate();
        break;
    }
    this.onSubmit();
  }
}
